function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#russians_svg__clip0_1_94)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.352 9.195a3.691 3.691 0 11-6.529 0c1.434-.087 2.656-.798 3.265-1.803.608 1.005 1.83 1.716 3.264 1.803zM7.231 2.793a2.216 2.216 0 11-4.286 0c.062.005.124.007.188.007.857 0 1.598-.42 1.955-1.03.356.61 1.098 1.03 1.954 1.03.064 0 .126-.002.189-.007zm2.944 8.12a5.088 5.088 0 11-10.152-.48C.098 9.326.342 8.22.884 7.115c.621-1.266.852-2.532.885-3.798a3.318 3.318 0 016.636 0c.037 1.282.268 2.54.885 3.798.534 1.09.78 2.18.858 3.27.018.173.027.349.027.526z",
  fill: "currentColor"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "russians_svg__clip0_1_94"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h11v16H0z"
})));

function SvgRussians(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgRussians;